export default __webpack_public_path__ + "static/media/bnb-coin.463d2dd9.png";